(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["yu-sei-waitlist"] && !Shopify.designMode) return;
  try {
    (() => {
    const elementName = 'yu-sei-waitlist-panel';
    if (customElements.get(elementName)) return;

    class YuSeiWaitlistPanel extends HTMLElement {
      connectedCallback() {
        // Children may still be parsing when a custom element connects.
        if (this.initialise()) return;
        this.childObserver = new MutationObserver(() => {
          if (this.initialise()) this.childObserver.disconnect();
        });
        this.childObserver.observe(this, { childList: true, subtree: true });
      }

      disconnectedCallback() {
        this.childObserver?.disconnect();
        this.controller?.abort();
        (this.timers || []).forEach(clearTimeout);
        clearTimeout(this.unlockTimer);
        if (this.input) this.input.disabled = true;
        if (this.button) this.button.disabled = true;
        this.ready = false;
        this.busy = false;
      }

      initialise() {
        if (this.ready) return true;
        this.form = this.querySelector('.yu-waitlist__form');
        this.input = this.querySelector('.yu-waitlist__input');
        this.field = this.querySelector('.yu-waitlist__field');
        this.button = this.querySelector('.yu-waitlist__submit');
        this.error = this.querySelector('.yu-waitlist__error');
        this.unsubscribeNote = this.querySelector('.yu-waitlist__unsubscribe');

        if (this.hidden || this.querySelector('.yu-waitlist__success')) return true;
        if (!this.form || !this.input || !this.field || !this.button || !this.error) return false;

        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const update = () => this.updateLabel();

        // Attach validation BEFORE enabling either control.
        this.button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.attemptSubmit();
        }, options);

        this.input.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' && !event.isComposing) {
            event.preventDefault();
            event.stopPropagation();
            this.attemptSubmit();
          }
        }, options);

        // Also guard Enter/programmatic requestSubmit calls.
        this.form.addEventListener('submit', (event) => {
          if (!this.validEmail()) {
            event.preventDefault();
            event.stopImmediatePropagation();
            this.unlock();
            this.showError();
          }
          // Valid submissions continue normally, including Shopify CAPTCHA.
        }, { capture: true, signal: this.controller.signal });

        this.input.addEventListener('focus', update, options);
        this.input.addEventListener('blur', update, options);
        this.input.addEventListener('input', () => {
          this.clearError();
          this.updateLabel();
        }, options);
        this.input.addEventListener('change', () => {
          this.clearError();
          this.updateLabel();
        }, options);
        this.input.addEventListener('invalid', (event) => {
          event.preventDefault();
          this.showError();
        }, options);
        this.form.addEventListener('reset', () => {
          setTimeout(() => {
            if (!this.isConnected) return;
            this.clearError();
            this.updateLabel();
          }, 0);
        }, options);
        window.addEventListener('pageshow', () => {
          this.unlock();
          this.updateLabel();
        }, options);

        this.form.noValidate = true;
        this.input.disabled = false;
        this.button.disabled = false;
        this.ready = true;
        this.busy = false;
        if (this.error.textContent.trim()) this.input.setAttribute('aria-invalid', 'true');
        this.updateLabel();
        this.timers = [100, 500, 1500].map((delay) => setTimeout(update, delay));
        return true;
      }

      updateLabel() {
        if (!this.input || !this.field) return;
        const filled = this.input.value.length > 0;
        const focused = document.activeElement === this.input;
        this.field.classList.toggle('is-floating', filled || focused);
        if (this.unsubscribeNote) this.unsubscribeNote.hidden = !filled;
      }

      validEmail() {
        const value = this.input.value.trim();
        this.input.value = value;
        // Read validity without opening the browser's validation popup.
        return value.length > 0 &&
          this.input.validity.valid &&
          /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
      }

      clearError() {
        this.error.textContent = '';
        this.input.removeAttribute('aria-invalid');
      }

      showError() {
        this.error.textContent = this.dataset.invalidEmailMessage || 'Email is invalid.';
        this.input.setAttribute('aria-invalid', 'true');
        this.input.focus({ preventScroll: true });
        this.updateLabel();
      }

      attemptSubmit() {
        if (!this.ready || this.busy) return;
        if (!this.validEmail()) {
          this.showError();
          return; // Crucially: no submit event, request, or navigation.
        }

        this.clearError();
        this.updateLabel();
        this.busy = true;
        this.input.readOnly = true;
        this.button.disabled = true;
        this.form.setAttribute('aria-busy', 'true');

        try {
          // Keep Shopify's normal form/CAPTCHA processing. Do not use submit().
          HTMLFormElement.prototype.requestSubmit.call(this.form);
        } catch (error) {
          this.unlock();
          this.error.textContent = this.dataset.sendErrorMessage || "We couldn't send your request. Please try again.";
        }

        // Allow retry if another script prevents navigation or a challenge waits.
        this.unlockTimer = setTimeout(() => this.unlock(), 12000);
      }

      unlock() {
        clearTimeout(this.unlockTimer);
        this.busy = false;
        if (this.input) this.input.readOnly = false;
        if (this.button && this.isConnected) this.button.disabled = false;
        this.form?.removeAttribute('aria-busy');
      }
    }

    customElements.define(elementName, YuSeiWaitlistPanel);
  })();
  } catch(e) { console.error(e); }
})();

})();
